import { render, staticRenderFns } from "./wb-question-details.vue?vue&type=template&id=e77a8524&scoped=true&"
import script from "./wb-question-details.vue?vue&type=script&lang=js&"
export * from "./wb-question-details.vue?vue&type=script&lang=js&"
import style0 from "./wb-question-details.vue?vue&type=style&index=0&id=e77a8524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77a8524",
  null
  
)

export default component.exports